import React, { Component } from 'react';

class LockedLink extends Component {
  static defaultProps = {
    text: "Upgrade to Unlock"
  }

  render() {
    let { text } = this.props;

    return (
      <div className="locked-link-overlay">
        <svg><use xlinkHref="#lock" /></svg>
        {text}
      </div>
    );
  }
}

export default LockedLink;



// WEBPACK FOOTER //
// ./src/components/Global/LockedLink.js